import React from 'react';
export default class IconLabel extends React.Component {
  render() {
    const name = this.props.name;
    return /*#__PURE__*/React.createElement("div", {
      className: "label",
      "aria-label": name,
      name: name
    }, /*#__PURE__*/React.createElement("div", {
      className: "icon-name",
      title: 'icon-name'
    }, name), /*#__PURE__*/React.createElement("div", {
      className: "icon-image",
      title: 'icon-image'
    }, this.props.children));
  }
}
//# sourceMappingURL=icon-label.js.map